import { tPatientModel } from 'src/app/models/tPatientModel';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tBillPayModel, tBillPayModelWithItemCateInfo, BillPay_Patient_PackageModel, BillPay_Patient_Relative_ChangeAccount, BillPay_PatientHistoryList, tBillPayReportModel, DayEndReportDataModel, PatientRelative_PackageModel, BillPayPaymenyByItemPackageModel,new_BillPay_PatientHistoryList } from '../models/tBillPayModel';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';

import { saveAs } from 'file-saver';
import { tConsultHeadModelWithPatientInfo } from '../models/tConsultHeadModel';
import { NavigationComponent } from '../pages/navigation/navigation.component';
import { ArAccountPaidBillModel } from '../pages/change-pay/change-pay-page/change-pay.component';
import { ARAccountPaidBillReceiptModel } from '../print/paid-change-pay-receipt-cert/paid-change-pay-receipt-cert.component';
import { ConsultStatusResponse } from './tOnConsult.service';
import { GetBillStatusResponse } from '../models/GetBillStatusResponse';



@Injectable({
    providedIn: 'root'
})

export class tBillPayService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tBillPay';

    getBillStatus(consultNumber:string){
      return this.http.get<GetBillStatusResponse>(this.baseurl + this.pathName + `/billStatus/${consultNumber}`);
    }

    getOutstandingByPatient(shopID:string,patientID:string){
      return this.http.get<ConsultStatusResponse>(this.baseurl + this.pathName + `/outstandingByPatient/${patientID}/${shopID}`);
    }

    getCTStatus(bpInvoiceNumber){
      return this.http.get<ConsultStatusResponse>(this.baseurl + this.pathName + '/CTStatus/' + bpInvoiceNumber);
    }

    getARAccountPaidBillReceipt(paymentNumber:string){
      return this.http.get<ARAccountPaidBillReceiptModel>(`${this.baseurl + this.pathName}/ARAccountPaidBillReceipt/${paymentNumber}`);
    }

    getARAccountPaidBills(){
      return this.http.get<ArAccountPaidBillModel[]>(`${this.baseurl + this.pathName}/ARAccountPaidBill`);
    }

    getPaymentHistory(patientID:string){
      return this.http.get<PaymentHistoryModel[]>(`${this.baseurl + this.pathName}/billHistory/patient/${patientID}`);
    }

    getAllData() {
        return this.http.get<tBillPayModel[]>(this.baseurl + this.pathName);
    }



    getDataByShopIDAndVoucherID(shopID: string, voucherID: string) {
        return this.http.get<tBillPayModelWithItemCateInfo[]>(this.baseurl + this.pathName + '/GetDataByVoucherID/' + shopID + '/' + voucherID);
    }

    getPatientPacketByItemID(patientID: string, itemID : string) {
        return this.http.get<PatientRelative_PackageModel>(this.baseurl + this.pathName + '/GetPatientPackage/' + patientID + '/' +itemID );
    }

    getPatientPacket_TotalAmountPackageOnly(patientID: string) {
        return this.http.get<PatientRelative_PackageModel>(this.baseurl + this.pathName + '/GetPatientPackageTotalAmount/' + patientID );
    }

    getPatientRelativeChangeAccount(patientID: string) {
        return this.http.get<BillPay_Patient_Relative_ChangeAccount[]>(this.baseurl + this.pathName + '/GetPatientRelativeChangeAccount/' + patientID );
    }


    getPatientHistoryList(patientID: string, shopID: string) {
        return this.http.get<BillPay_PatientHistoryList[]>(this.baseurl + this.pathName
            + '/GetPatientHistoryList/' + patientID + '/' + shopID );
    }
    getPatientHistoryList2(patientID: string, shopID: string,searchDate:string,searchDateTo:string) {
        return this.http.get<new_BillPay_PatientHistoryList[]>(this.baseurl + this.pathName
            + '/GetPatientHistoryList2/' + patientID + '/' + shopID +'/'+searchDate+'/'+searchDateTo);
    }
    getDayEndReportData(shopID:string,searchDate: string){
        return this.http.get<DayEndReportDataModel>(this.baseurl + this.pathName + '/GetDayEndReportData/' + shopID+"/"+searchDate );

    }

    // getDataById(id: string) {
    //     return this.http.get<tBedModel>(this.baseurl + this.pathName + '/' + id);
    // }

    // addData(data: tBedModel) {
    //     return this.http.post(this.baseurl + this.pathName, data);
    // }

    // deleteData(data: tBedModel) {
    //     return this.http.delete(this.baseurl + this.pathName + '/' + data.bedID);
    // }

    updateData(data: tBillPayModel) {
        return this.http.put(this.baseurl + this.pathName + '/UpdateRowRecord', data);
    }

    updateManyData(data: tBillPayModel[]) {
        return this.http.put(this.baseurl + this.pathName + '/UpdateManyRowRecord', data);
    }

    updateCancelChangeAccData(data: tBillPayModel[]) {
        return this.http.put(this.baseurl + this.pathName + '/UpdateManyRowRecord_CancelChangeAcc', data);
    }

    changeMultiPaymentData(data: tBillPayModel[]) {
        return this.http.post(this.baseurl + this.pathName + '/PostChangeMultiPayment', data);
    }

    addData(data: tBillPayModel) {
        return this.http.post(this.baseurl + this.pathName + '/postItemInfo', data).pipe(shareReplay(1));
    }

    paymentByItemPackage(data: BillPayPaymenyByItemPackageModel) {
        return this.http.post(this.baseurl + this.pathName + '/postPaymentByItemPackage', data).pipe(shareReplay(1));
    }

    addWalkInMultiData(dataList: tBillPayModel[]) {
        return this.http.post(this.baseurl + this.pathName + '/PostMultiRecord/WalkInItem', dataList);
    }



    addPayment(data: tBillPayModel) {
        return this.http.post(this.baseurl + this.pathName + '/postPaymentnfo', data);
    }

    deleteData(data: tBillPayModel) {
        return this.http.delete(this.baseurl + this.pathName + '/DeleteData/' + data.id);
    }

    VoidPayment(voidPaymentNumber: string) {
        // return this.http.post(this.baseurl + this.pathName + '/VoidPayment/' + voidPaymentNumber + '/' + NavigationComponent.userID
        // , voidPaymentNumber);

        //v2
        return this.http.post(this.baseurl + this.pathName + '/VoidPayment/v2/' + voidPaymentNumber, voidPaymentNumber);
    }



    VoidBill(voidBillingNumber: string) {
        // return this.http.post(this.baseurl + this.pathName + "/VoidPayment/"+ voidPaymentNumber);
        return this.http.post(this.baseurl + this.pathName + '/VoidBill/' + voidBillingNumber + '/' + NavigationComponent.userID
        , voidBillingNumber);
    }


    GetBillPayDetails(shopID: string) {
        // return this.http.post(this.baseurl + this.pathName + "/VoidPayment/"+ voidPaymentNumber);
        return this.http.get<tBillPayReportModel[]>(this.baseurl + this.pathName + '/GetBillPayDetails/' + shopID);
    }

    lockPres(shopID: string, clthConsultNumber: string, billingNum: string) {

        const data = new Array;
        return this.http.post(this.baseurl + this.pathName + '/lockPres/' + shopID + '/' + clthConsultNumber + '/' + billingNum, data);
    }


    UpdatePrescriptionPrice(shopID: string, clthConsultNumber: string, prescriptionNumber: string, billPayID: string) {

        const data = new Array;
        return this.http.post(this.baseurl + this.pathName + '/UpdatePrescriptionPrice/' + shopID + '/' + clthConsultNumber + '/' + prescriptionNumber + '/'+billPayID, data);
    }


    WalkinChangePatient(bpInvoiceNumber : string , clthConsultNumber : string,data: tPatientModel ){
        return this.http.post(this.baseurl + this.pathName + '/WalkinChangePatient/' + bpInvoiceNumber + '/' + clthConsultNumber, data);

    }

    GetBillPayDetailsReport(shopID: string, currentDate: string) {
        // return this.http.post(this.baseurl + this.pathName + "/VoidPayment/"+ voidPaymentNumber);
        return this.http.get<tBillPayReportModel[]>(this.baseurl + this.pathName + '/GetBillPayDetailsReport/'
        + shopID + '/' + currentDate);
    }


    GetBackEndBillPayDetailsReport() {
        return this.http.get<Blob>(this.baseurl + '/DayEndDetailsReports', { responseType: 'blob' as 'json' });
    }

    UpdatePrintName(printNameMode: string, userID: string, data: tBillPayModel[]) {
        return this.http.put(this.baseurl + this.pathName + '/UpdatePrintName/' + printNameMode + '/' + userID, data);
    }

    //copy from ECPASS; Check if the bill is missing the prescription
    checkBillPayPres(consultNumber: string) {
      return this.http.post<any>(this.baseurl + this.pathName + '/checkBillPayPres/' + consultNumber,consultNumber);
    }

    GetBillStatus(bpInvoiceNumber:string){
      return this.http.get<any>(this.baseurl + this.pathName + '/invoiceStatus/' + bpInvoiceNumber);
  }

}
